import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { lastValueFrom } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AiAssistantPromptRequest, AiAssistantPromptResponse } from '../models/ai-assistant.models';
import { OpenAiRunPromptResponse } from '../models/open-ai.models';

@Injectable({
  providedIn: 'root',
})
export class AiAssistantService {
  private http = inject(HttpClient);

  runAiAssistantPrompt(prompt: string, conversationId: string | null): Promise<AiAssistantPromptResponse> {
    const request: AiAssistantPromptRequest = { prompt };
    if (conversationId) {
      request.conversationId = conversationId;
    }

    return lastValueFrom(this.http.post<AiAssistantPromptResponse>(`${environment.adminBaseUrl}/api/ai-assistant/prompt`, request));
  }

  getPromptResponse(prompt: string): Promise<OpenAiRunPromptResponse> {
    return lastValueFrom(this.http.post<OpenAiRunPromptResponse>(`${environment.adminBaseUrl}/api/OpenAi/run-prompt`, { prompt }));
  }
}
